import script from "./adsrewards.vue?vue&type=script&setup=true&lang=js"
export * from "./adsrewards.vue?vue&type=script&setup=true&lang=js"

import "./adsrewards.vue?vue&type=style&index=0&id=6c2e6fa0&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/pay.7pa.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c2e6fa0"]])

export default __exports__